<template>
    <div class="form__item a-modal__separator">
        <div class="form__item">
            <el-switch v-if="isAdmin" :inactive-text="$lang('admin.addPartner.referral.placeholder')" class="switch switch--small switch--label" v-model="enabled"></el-switch>

            <span v-else class="form__label">{{ $lang('admin.addPartner.referral.main.title') }}</span>
        </div>

        <div v-if="enabled" class="form__item">
            <div class="form__item">
                <div v-if="isAdmin">
                    <span class="form__label">{{ $lang('admin.addPartner.referral.commission.admin') }}</span>

                    <el-popover v-model="errors.commission.isError"
                                trigger="manual"
                                placement="top"
                                width="300"
                                popper-class="add__error-popover"
                                :content="errors.commission.message">
                        <el-select slot="reference"
                                   :class="{ 'add__error': errors.commission.isErrorPaint }"
                                   @focus="clearErrors"
                                   placeholder="20%"
                                   class="a-modal__small"
                                   v-model="commission"
                                   :loading-text="$lang('el-select.loading')"
                                   :noDataText="$lang('el-select.noDataText')"
                                   :noMatchText="$lang('el-select.noMatchText')"
                                   :readonly="commissionSelect.readonly"
                                   required>
                            <el-option v-for="item in commissionSelect.values"
                                       :key="item"
                                       :value="item"
                                       :lable="item + '%'">
                            </el-option>
                        </el-select>
                    </el-popover>
                </div>

                <div v-else>
                    <span class="form__label">{{ $lang('admin.addPartner.referral.commission.other') }}</span>

                    <el-input slot="reference"
                              :readonly="link.readonly"
                              :placeholder="$lang('admin.addPartner.referral.link2')" class="input input--small a-modal__xs"
                              :value="commission">
                    </el-input>
                </div>
            </div>

            <div class="form__item">
                <div class="form__item">
                    <el-switch v-if="isAdmin" :inactive-text="$lang('admin.addPartner.referral.link')" class="switch switch--small switch--label" v-model="linkEnabled"></el-switch>

                    <span v-else-if="linkEnabled" class="form__label">{{ $lang('admin.addPartner.referral.title') }}</span>
                </div>

                <div v-if="linkEnabled">
                    <div class="form__item form__item--inline">
                        <div class="form__inner form__inner--w100 a-modal__big a-modal__big form__inner--relative ">
                            <el-input slot="reference"
                                      :readonly="link.readonly"
                                      :placeholder="$lang('admin.addPartner.referral.link.placeholder')" class="input input--big input--copy"
                                      v-model="this.link.value">
                            </el-input>
                            <button type="button" @click="copy(link.value)" class="btn input__copy">
                                <svg width="17" height="17">
                                    <use xlink:href="/assets/front/img/sprite.svg#icon-copy"></use>
                                </svg>
                            </button>
                        </div>
                        <div class="form__inner">
                            <a v-if="isAdmin && $route.name !== 'partner'" class="btn btn--big btn--main-bg" :href="adminLink">{{ $lang('admin.addPartner.referral.stat') }}</a>
                            <a v-else-if="$route.name !== 'partner'" class="btn btn--big btn--main-bg" href="/cabinet/statistics">{{ $lang('admin.addPartner.referral.stat') }}</a>
                        </div>
                    </div>

                    <qr-code-preview v-if="link.value !== ''"
                                     :link="link.value"
                                     :preview-without-project="true"
                                     :with-latin-project="locale !== 'ru'">
                    </qr-code-preview>
                </div>
            </div>

            <div class="form__item" v-if="partnerId">
                <div class="form__item">
                    <el-table
                        :data="domains"
                        stripe
                        cell-class-name="table__cell"
                        header-cell-class-name="table__header-cell"
                        :emptyText="$lang('table.empty')"
                        class="table">
                        <el-table-column
                            name="user.name"
                            :label="$lang('admin.addPartner.referral.domains.table.label.domain')"
                            min-width="180">
                            <template slot-scope="scope">
                                <span class="table__cell-limit table__cell-bold">{{ scope.row.name }}</span>
                            </template>
                        </el-table-column>

                        <el-table-column
                            name="user.name"
                            :label="$lang('admin.addPartner.referral.domains.table.label.status')"
                            min-width="180">
                            <template slot-scope="scope">
                                {{ getDomainStatusName(scope.row) }}

                                <el-popover
                                    v-if="!scope.row.verified"
                                    class="tariffs__popover"
                                    placement="bottom"
                                    width="290"
                                    trigger="hover"
                                >
                                    <template>
                                        <div class="form__item form__item--small-margin">
                                            <span class="form__label form__label--mb0">
                                                {{ $lang('admin.addPartner.referral.domains.popover.label.tag') }}
                                            </span>
                                        </div>

                                        <div class="form__item form__item--small-margin">
                                            {{ $lang('admin.addPartner.referral.domains.popover.label.tag.desc') }}
                                        </div>

                                        <div class="form__item form__item--small-margin">
                                            <div class="form__inner form__inner--w100 a-modal__big a-modal__big form__inner--relative ">
                                                <el-input slot="reference"
                                                          :readonly="true"
                                                          :placeholder="$lang('admin.addPartner.referral.domains.popover.label.tag.placeholder')"
                                                          class="input input--big input--copy"
                                                          :value="getDomainVerificationTag(scope.row)">
                                                </el-input>
                                                <button type="button" @click="copy(getDomainVerificationTag(scope.row))" class="btn input__copy">
                                                    <svg width="17" height="17">
                                                        <use xlink:href="/assets/front/img/sprite.svg#icon-copy"></use>
                                                    </svg>
                                                </button>
                                            </div>
                                        </div>

                                        <div class="form__item form__item--small-margin">
                                            <span class="form__label form__label--mb0">
                                                {{ $lang('admin.addPartner.referral.domains.popover.label.file') }}
                                            </span>
                                        </div>

                                        <div class="form__item form__item--small-margin">
                                            {{ $lang('admin.addPartner.referral.domains.popover.label.file.desc') }}
                                        </div>

                                        <div class="form__item form__item--small-margin">
                                            <a class="btn btn--border-bg btn--middle btn--w100"
                                               :href="'/download/domain-verification-file/' + scope.row.id"
                                            >
                                                {{ $lang('admin.addPartner.referral.domains.popover.button.download') }}
                                            </a>
                                        </div>

                                        <button class="btn btn--main-bg btn--middle btn--w100" @click.prevent="verifyDomain(scope.row)">
                                            {{ $lang('admin.addPartner.referral.domains.popover.button.verify') }}
                                        </button>
                                    </template>

                                    <template #reference>
                                        <img class="tariffs__popover--icon" slot="reference" src="/assets/front/img/popover.svg" alt="#">
                                    </template>
                                </el-popover>
                            </template>
                        </el-table-column>

                        <el-table-column
                            width="45">
                            <template slot-scope="scope">
                                <el-popover
                                    placement="left-end"
                                    width="320"
                                    popper-class="a-popover"
                                    :visible-arrow="false"
                                    trigger="click">
                                    <div class="a-popover__wrapper">
                                        <div class="a-popover__section a-popover__section--no-border">
                                            <span class="a-popover__section-title">
                                                {{ $lang('admin.addPartner.referral.domains.controls.title') }}
                                            </span>

                                            <button class="btn a-popover__section-item" @click.prevent="removeDomain(scope.row)">
                                                {{ $lang('admin.addPartner.referral.domains.controls.button.remove') }}
                                            </button>
                                        </div>
                                    </div>
                                    <button slot="reference" class="btn a-filters__more" @click.prevent>
                                        <svg width="22" height="22">
                                            <use xlink:href="/assets/front/img/sprite.svg#icon-more"></use>
                                        </svg>
                                    </button>
                                </el-popover>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>

                <div class="form__item form__item--inline">
                    <div class="form__inner form__inner--w100 a-modal__big a-modal__big form__inner--relative">
                        <el-popover v-model="errors.domain.isError"
                                    trigger="manual"
                                    placement="top"
                                    width="300"
                                    popper-class="add__error-popover"
                                    :content="errors.domain.message">
                            <el-input slot="reference"
                                      :class="{ 'add__error': errors.domain.isErrorPaint }"
                                      @focus="clearErrors"
                                      :placeholder="$lang('admin.addPartner.referral.domains.add.input.placeholder')"
                                      class="input input--big input--copy"
                                      v-model="domain">
                            </el-input>
                        </el-popover>
                    </div>

                    <div class="form__inner">
                        <button class="btn btn--big btn--main-bg" @click.prevent="createDomain">
                            {{ $lang('admin.addPartner.referral.domains.add.button') }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import errors from '../../../mixins/errors';
import ApiService from "../../../api/api";
import QrCodePreview from "../page/childrens/QrCodePreview";
import table from "../../../mixins/table";
import ActiveSwitch from "../activeSwitch";

export default {
    name: 'EditReferral',
    components: {QrCodePreview, ActiveSwitch},
    mixins: [errors, table],
    props: [
        'referralEnabled',
        'referralLinkEnabled',
        'referralSlug',
        'referralCommission',
        'domains',
        'partnerId'
    ],
    computed: {
      adminLink() {
        return this.$router.resolve({
              name: 'partner-statistics',
              params: {partnerId: this.$route.params.id}
            }
        ).href;
      }
    },
    data() {
        return {
            locale: window.laravel.locale,
            isAdmin: window.laravel.isAdmin,
            enabled: this.referralEnabled ?? false,
            linkEnabled: this.referralLinkEnabled ?? false,
            link: {
                value: '',
                readonly: true,
            },
            domain: null,
            commissionSelect: {
                values: [3, 5, 10, 15, 20, 25, 30, 40],
                readonly: true,
            },
            commission: this.referralCommission,
            errors: {
                commission: {
                    isError: false,
                    message: ''
                },
                domain: {
                    isError: false,
                    message: ''
                }
            }
        }
    },
    mounted() {
        this.$on('reload', () => {
            this.enabled = this.referralEnabled;
            this.linkEnabled = this.referralLinkEnabled;
            this.commission = this.referralCommission;

            this.updateReferralLink();
        });

        this.updateReferralLink();
    },
    watch: {
        enabled: function(val) {
            this.returnEnabled();
        },
        linkEnabled: function(val) {
            this.returnLinkEnabled();
        },
        commission: function(val) {
            this.returnCommission();
        }
    },
    methods: {
        updateReferralLink() {
            if(this.referralSlug) {
                this.generateLink(this.referralSlug);
            } else {
                this.generateSlug();
            }
        },
        returnEnabled() {
            this.$emit('update:referralEnabled', this.enabled);
        },
        returnLinkEnabled() {
            this.$emit('update:referralLinkEnabled', this.linkEnabled);
        },
        returnCommission() {
            this.$emit('update:referralCommission', this.commission);
        },
        copy(value) {
            navigator.clipboard.writeText(value);
        },
        generateSlug() {
            ApiService.get('/referral/generate-slug')
                .then((response) => {
                    this.$emit('update:referralSlug', response.data);
                    this.generateLink(response.data);
                });
        },
        generateLink(slug) {
            let host = window.laravel.appUrlByLocale;

            if (this.locale !== 'ru' && this.locale !== 'en') {
                host += '/' + this.locale;
            }

            this.link.value = host + '/referral/' + slug;
        },
        createDomain() {
            this.$loading(this.$optionsLoading);

            ApiService.post('/partner/create-domain', { partner_id: this.partnerId, domain: this.domain.toLowerCase() })
                .then((response) => {
                    this.domains.push(response.data);
                    this.domain = null;
                })
                .catch((error) => {
                    this.createErrors(error.response.data.errors);
                })
                .finally(() => {
                    this.$loading({}).close();
                });
        },
        verifyDomain(domain) {
            this.$loading(this.$optionsLoading);

            ApiService.update('/partner/verify-domain/' + domain.id)
                .then((response) => {
                    domain.verified = response.data.verified;
                })
                .catch((error) => {
                    this.createErrors(error.response.data.errors);
                })
                .finally(() => {
                    this.$loading({}).close();
                });
        },
        removeDomain(domain) {
            this.$loading(this.$optionsLoading);

            ApiService.delete('/partner/remove-domain/' + domain.id)
                .then((response) => {
                    this.domains.splice(this.domains.indexOf(domain), 1);
                })
                .catch((error) => {
                    this.createErrors(error.response.data.errors);
                })
                .finally(() => {
                    this.$loading({}).close();
                });
        },
        getDomainVerificationTag(domain) {
            return '<meta name="mc-domain-verification" content="' + domain.token + '" />';
        },
        getDomainStatusName(domain) {
            return domain.verified ? this.$lang('admin.addPartner.referral.domains.status.on') : this.$lang('admin.addPartner.referral.domains.status.wait') ;
        }
    }
}
</script>
